import React, { FC, useEffect, useState, useRef } from 'react';
import translate from '@translate';
import { useDispatch, useSelector } from 'react-redux';
import { setLocationParams } from 'src/resources/location/reducer';
import TopBlock from './TopBlock';
import { getProductSetsListFetch } from 'src/resources/productSetsList/reducer';
import { RootStoreType } from 'src/types/store';
import { allColumns } from './constants';
import { InventoryIcon } from 'src/components/SkladonIcon/Icons';
import TableSimple from 'src/components/TableSimple';
import { ExportTypeType, TableRefType } from 'src/types/table';
import { useCheckPermission } from 'src/utils/checkPermission';
import ConfirmDialog, { ConfirmDialogStatePropsType } from 'src/components/ConfirmDialog';

const ProductSetsListContainer: FC = () => {
    const dispatch = useDispatch();
    const tableRef = useRef<TableRefType>();

    const loading = useSelector((state: RootStoreType) => state.productSetsList.loading);
    const productSetsData = useSelector((state: RootStoreType) => state.productSetsList.data);
    const productInsetTypeCodes = useSelector(
        (state: RootStoreType) => state.constantsCodes.data.productInsetTypeCodes
    );

    const permissionCreate = useCheckPermission('PRODUCT_SET.CREATE');
    const permissionDetail = useCheckPermission('PRODUCT_SET.DETAIL');

    const [confirmParams, setConfirmParams] = useState<ConfirmDialogStatePropsType | null>(null);

    useEffect(() => {
        dispatch(setLocationParams({ name: translate('productSets.title') }));
        dispatch(getProductSetsListFetch());
    }, []);

    const reloadProductSetsList = () => {
        dispatch(getProductSetsListFetch());
    };

    const handleExport = (type: ExportTypeType) => {
        tableRef.current?.exportTable(type, translate('productSets.action.exportFileName'));
    };

    return (
        <>
            <TopBlock
                reloadProductSetsList={reloadProductSetsList}
                permissionCreate={permissionCreate}
                handleExport={handleExport}
            />
            <TableSimple
                tableRef={tableRef}
                rowIdKey="SET_SKU"
                rows={productSetsData || []}
                loading={loading}
                columsLabelPrefix="productSets.table"
                allColumns={allColumns}
                initSort={{ column: 'SET_SKU', direction: 'DESC' }}
                rowActions={[
                    {
                        icon: <InventoryIcon />,
                        label: translate('productSets.action.productSetDetail'),
                        getLink: (row) => `/products/${row.MASTER_PRODUCT_ID}/`,
                        hiddenFce: () => !permissionDetail,
                    },
                ]}
                selectOptions={{
                    productInsetTypeCodes,
                }}
                heightVariant="top-tab"
                fullHeight
                optionsSessionName="productSetsTable"
            />
            {confirmParams && (
                <ConfirmDialog
                    title={confirmParams.title}
                    content={confirmParams.content}
                    action={confirmParams.action}
                    onClose={(): any => setConfirmParams(null)}
                />
            )}
        </>
    );
};

export default ProductSetsListContainer;
